import {
  FETCH_ALL_MATERIAL_TYPES,
} from '../../mutation-types';

export default {
  [FETCH_ALL_MATERIAL_TYPES](state, materialTypes) {
    state.all = materialTypes;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/materialType/mutations.js